import { usePathname } from "next/navigation";
import { useCallback } from "react";
import { resolveHref } from "./product-pages";

// The map and the pure helpers live in `product-pages.ts` so the server can read them too;
// re-exported here so every existing `@/lib/links` import keeps working.
export { PRODUCT_PAGES, productSlugOf, resolveHref } from "./product-pages";

export function useResolveHref() {
  const pathname = usePathname();
  return useCallback((href: string) => resolveHref(href, pathname), [pathname]);
}
